import React, { useEffect, useRef } from "react";

import Header from "../layout/Header";
import "./index.scss";
import video from "../../assets/video.mp4";

const SlideRealisation = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (videoRef.current) {
          if (entry.isIntersecting) {
            videoRef.current.play();
          } else {
            videoRef.current.pause();
          }
        }
      },
      {
        threshold: 0.5, // La vidéo doit être à moitié visible pour déclencher l'action
      }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);
  return (
    <div className="slide-realisation">
      <video
        className="background-video"
        ref={videoRef}
        autoPlay
        loop
        playsInline
        src={video}
        // Remplacez ce chemin par votre vidéo
      />
      <Header />
      <div className="slide-realisation-container ">
        <div className="row w-100 d-flex align-items-end h-100 mb-5">
          <div className="col-lg-7">
            <div className="slide-realisation-container-content ">
              <h1 className="slide-realisation-container-content-title">
                Nos réalisations sur le terrain
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideRealisation;
